import React from 'react';
import {orgId} from '../../../context/context';

export default class Step3 extends React.Component {

  render() {
    return <div className={this.props.className || ''}>
      <ul style={{ lineHeight: '1.8em' }}>
        <li>On your online store, navigate to the product page where the form is displayed.</li>
        <li>Enter some values and add the product to the cart.</li>
        <li>You should see the form values in the cart. Please <a href={`/get-in-touch?shop=${orgId}`}>get in touch</a> if not.</li>
      </ul>
    </div>
  }

}
